function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "sun-f",
  d: "M10,15.565a5,5,0,1,1,5-5A5,5,0,0,1,10,15.565Zm0-15a1,1,0,0,1,1,1v2a1,1,0,0,1-2,0v-2A1,1,0,0,1,10,.565Zm0,16a1,1,0,0,1,1,1v2a1,1,0,0,1-2,0v-2A1,1,0,0,1,10,16.565Zm-9-7H3a1,1,0,1,1,0,2H1a1,1,0,1,1,0-2Zm16,0h2a1,1,0,0,1,0,2H17a1,1,0,0,1,0-2Zm.071-6.071a1,1,0,0,1,0,1.414L15.657,6.322a1,1,0,1,1-1.414-1.414l1.414-1.414a1,1,0,0,1,1.414,0ZM5.757,14.808a1,1,0,0,1,0,1.414L4.343,17.636a1,1,0,1,1-1.414-1.414l1.414-1.414a1,1,0,0,1,1.414,0ZM4.343,3.494,5.757,4.908A1,1,0,1,1,4.343,6.322L2.93,4.908A1,1,0,1,1,4.344,3.494ZM15.657,14.808l1.414,1.414a1,1,0,1,1-1.414,1.414l-1.414-1.414a1,1,0,1,1,1.414-1.414Z",
  transform: "translate(0 -0.565)",
  fill: "#fff"
});

function SvgIcHabitSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitSun);
export default ForwardRef;